import c from './index.less';

export default function NewFeatureTag() {
    return (
        <div className={c['newFeatureTag']}>
            NEW
        </div>
    );
}
